/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Avatar, Popover } from 'antd';
import { Link } from 'react-router-dom';

import { userSignOut } from '../../redux/actions/Auth';
import { history } from '../../redux/store';
import placeholder from '../../assets/images/placeholder.jpg';

const UserInfo = () => {
  const dispatch = useDispatch();
  const { full_name } = useSelector(({ auth }) => auth.authUser);

  const userMenuOptions = (
    <ul className="gx-user-popover">
      <li>
        <Link to="/profile">
          <span>Profile</span>
        </Link>
      </li>
      <li>
        <Link to="" onClick={() => dispatch(userSignOut())}>
          <span>Sign Out</span>
        </Link>
      </li>
    </ul>
  );

  return (

    <div className="gx-flex-row gx-align-items-center gx-avatar-row">
      <Popover placement="bottomRight" content={userMenuOptions} trigger="click">
        <Avatar
          src={placeholder}
          className="gx-size-40 gx-pointer gx-mr-3"
          alt=""
        />
        <span className="gx-avatar-name">
          <i
            className="icon icon-chevron-down gx-fs-xxs gx-ml-2"
          />
        </span>
      </Popover>
    </div>

  );
};

export default UserInfo;
